import React from "react";
import PropTypes from "prop-types";

// core components
import AssetDownload, {
    HeroAsset,
    Sidebar,
    DownloadButtons
} from "core/AssetDownload";

// assetDownloadConfig
import { assetDownloadConfig } from "./assetDownloadConfig";

// components
import HeroImage from "./components/HeroImage";
import DownloadPhotoButton from "./components/DownloadPhotoButton";
import PurchaseTypeDrawer from "./components/PurchaseTypeDrawer";

const PhotoDetailSteps = ({ photo }) => {
    return (
        <AssetDownload
            asset={photo}
            assetType="photo"
            assetDownloadConfig={assetDownloadConfig}
        >
            <HeroAsset>
                <HeroImage />
            </HeroAsset>
            <PurchaseTypeDrawer />
            <Sidebar>
                <DownloadButtons>
                    <DownloadPhotoButton />
                </DownloadButtons>
            </Sidebar>
        </AssetDownload>
    );
};

export default PhotoDetailSteps;

// prop-types
PhotoDetailSteps.propTypes = {
    photo: PropTypes.object
};
